"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const native_base_1 = require("native-base");
const react_1 = require("react");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const react_redux_1 = require("react-redux");
const react_native_track_player_1 = __importDefault(require("react-native-track-player"));
const navigation_1 = __importDefault(require("./navigation"));
const store_1 = require("./store");
const DeviceProvider_1 = __importDefault(require("./providers/DeviceProvider"));
const DocumentsProvider_1 = __importDefault(require("./providers/DocumentsProvider"));
const AudioProvider_1 = __importDefault(require("./providers/AudioProvider"));
const redux_persist_1 = require("redux-persist");
const react_2 = require("redux-persist/integration/react");
const react_native_keyboard_controller_1 = require("react-native-keyboard-controller");
const react_query_1 = require("@tanstack/react-query");
const fontawesome_svg_core_1 = require("@fortawesome/fontawesome-svg-core");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const queryClient = new react_query_1.QueryClient();
react_native_track_player_1.default.setupPlayer();
fontawesome_svg_core_1.library.add(pro_regular_svg_icons_1.far, pro_light_svg_icons_1.fal, pro_solid_svg_icons_1.fas);
const App = () => {
    const persistor = (0, react_1.useMemo)(() => ((0, redux_persist_1.persistStore)(store_1.store)), []);
    return ((0, jsx_runtime_1.jsx)(react_redux_1.Provider, { store: store_1.store, children: (0, jsx_runtime_1.jsx)(react_2.PersistGate, { loading: null, persistor: persistor, children: (0, jsx_runtime_1.jsx)(react_query_1.QueryClientProvider, { client: queryClient, children: (0, jsx_runtime_1.jsx)(react_native_safe_area_context_1.SafeAreaProvider, { children: (0, jsx_runtime_1.jsx)(native_base_1.NativeBaseProvider, { children: (0, jsx_runtime_1.jsx)(react_native_keyboard_controller_1.KeyboardProvider, { children: (0, jsx_runtime_1.jsx)(DeviceProvider_1.default, { children: (0, jsx_runtime_1.jsx)(DocumentsProvider_1.default, { children: (0, jsx_runtime_1.jsx)(AudioProvider_1.default, { children: (0, jsx_runtime_1.jsx)(navigation_1.default, {}) }) }) }) }) }) }) }) }) }));
};
exports.default = App;
